import { useState, useEffect } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import api from '../api/api'; // Axios wrapper;
import WatchlistFormStatic from './WatchlistFormStatic';
import WatchlistFormDynamic from './WatchlistFormDynamic';


function WatchListModal({ show, onHide, newWatchlistOption, onSubmit
 }) {
  const [watchListId, setWatchListId] = useState("");
  const [addNewWatchlist, setAddNewWatchlist] = useState(false);
  const [watchlists, setWatchlists] = useState([]);
  const watchlistMap = new Map();
  const [loading, setLoading] = useState(false);
  const useDynamicForm = true;

  useEffect(() => {
      setLoading(true);
      Promise.all([
        api.get('/getUserWatchlists')
      ]).then(([user_watchlists]) => {
        setWatchlists(user_watchlists.data?.user_watchlists);
        console.log("*** useEffect watchlists - ", user_watchlists);
        watchlists.map(watchlistData => watchlistMap.set(watchlistData.user_watchlist_id, watchlistData.watchlist_name)) ;
      }).finally(() => {
          setLoading(false);
    })
  }, []);  

  const handleChange = (e) => {
    setAddNewWatchlist(e.target.checked);
  }
  const handleSubmit = () => {
    if (!watchListId.trim()) return;

    console.log("**** WatchListModal called ", watchListId)
    onSubmit({
      'watchlistName': watchListId.trim(),
      'addNewWatchlist': addNewWatchlist
    });

    setWatchListId("");
    setAddNewWatchlist(false);
  };


  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>Select WatchList</Modal.Title>
      </Modal.Header>

      {
        useDynamicForm ? (
            <Modal.Body>
              <WatchlistFormDynamic
                   userWatchlist = {watchlists}
                   newWatchlistOption={newWatchlistOption}
                   onHide = {onHide}
                   onSubmit={onSubmit} 
              />
            </Modal.Body>
          ) : (
            <>
              <Modal.Body>
                <WatchlistFormStatic
                    watchlists = {watchlists}
                    newWatchlistOption={newWatchlistOption}
                    watchListId = {watchListId}
                    onWatchlistIdChange = { (watchListId) => setWatchListId(watchListId)}
                    addNewWatchlist = {addNewWatchlist}
                    onAddNewWatchlist = { (addNewWatchlist) => setAddNewWatchlist(addNewWatchlist)}
                />
              </Modal.Body>

              <Modal.Footer>
                <Button variant="secondary" onClick={onHide}>
                  Cancel
                </Button>

                <Button variant="primary" onClick={handleSubmit}>
                  Continue
                </Button>
              </Modal.Footer>
            </>
          )
      }
    </Modal>
  );
}

export default WatchListModal;